/**
 * This function returns null.
 * Useful as a default React component (unlike noop, this actually
 *  renders nothing).
 */
export default function stubNull() { return null; }